import { render, staticRenderFns } from "./ConStyle1Edit.vue?vue&type=template&id=12701d28"
import script from "./ConStyle1Edit.vue?vue&type=script&lang=js"
export * from "./ConStyle1Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports